export const MODIFY_CHAT_FILE_SELECTED = 'MODIFY_CHAT_FILE_SELECTED';

export function modifyChatFileSelected(chatFileSelected){
    return{
        type: 'MODIFY_CHAT_FILE_SELECTED',
        mainState: {
            chatFileSelected: chatFileSelected
        }
    }
}